import React from "react";
import Tour, { ReactTourContent } from "@inspinia-react/tour";

export default props => {
  return (
    <Tour
      onCloseTour={() => {
        if (props.onTourComplete) {
          props.onTourComplete();
        }
      }}
      badgeVerbose
      steps={[
        {
          selector: "create-product",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center pb-1">Cadastrar Produto</h2>
              <h3>Vamos conhecer como cadastrar um produto?</h3>
              <h4>Clique na seta direita para começar</h4>
            </ReactTourContent>
          )
        },
        {
          selector: "#product-barcode-input",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center py-2">Importar Produto</h2>
              <p>
                O sistema é capaz de detectar um produto pelo código de barras,
                assim o cadastro fica muito mais ágil
              </p>
            </ReactTourContent>
          ),
          action: node => {
            node.focus();
          }
        },
        {
          selector: "[data-product-base-generate-internalcode]",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center py-2">Código interno</h2>
              <p>
                O sistema gera, automaticamente, um código interno para
                identificar seu produto, mas você também pode inseri-lo,
                contanto que ele seja unico.
              </p>
            </ReactTourContent>
          ),
          action: node => {}
        },
        {
          selector: "[data-product-base]",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center py-2">Detalhes do Produto</h2>
              <p>
                Começaremos preenchendo as informações basicas do produto como
                nome, preço de vendas e preço de custo.{" "}
              </p>
            </ReactTourContent>
          ),

          action: node => {
            node.focus();
          }
        },
        {
          selector: "[data-product-base-info]",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center py-2">Informações do produto</h2>
              <p>
                Em seguida, forneceça as informações como unidades, categorias,
                fornecedor e estoque inicial.
              </p>
            </ReactTourContent>
          ),
          action: node => {
            node.focus();
          }
        },
        {
          selector: "#product-initial-stock",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center py-2">Iniciar estoque</h2>
              <p>
                Você pode cadastrar um produto e já iniciar com uma quantidade
                em estoque.
              </p>
            </ReactTourContent>
          ),
          action: node => {
            node.focus();
          }
        },
        {
          selector: "#btn-save-product",
          content: ({ goTo, inDOM, step }) => (
            <ReactTourContent goTo={goTo} inDOM={inDOM} step={step}>
              <h2 className="text-center py-2">Para finalizar</h2>
              <p>
                Após o termino do preenchimento, você tem que clicar em Salvar,
                para que seu produto possa ser criado
              </p>
              <button
                className="btn btn-secondary btn-block"
                onClick={() => {
                  if (props.onTourComplete) {
                    props.onTourComplete();  
                  }
                }}
              >
                Criar produto
              </button>
            </ReactTourContent>
          )
        }
      ]}
    ></Tour>
  );
};



// WEBPACK FOOTER //
// ./src/components/tours/create-tour.jsx